import { QuickConfirmQuestionConfig } from '@gripp/shared-logic';
import { OptionList, RuledLines } from '../components/printPrimitives';
import { RoutinePrintQuestion } from './types';

export const QuickConfirmPrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const quickConfirm = config as QuickConfirmQuestionConfig;
  const options = quickConfirm.options ?? [];

  if (options.length === 0) return <RuledLines />;

  return <OptionList options={options} glyph="radio" />;
};
